import ServicePageTemplate from '@/pages/services/components/ServicePageTemplate';
import { salesOperations } from '@/mocks/servicePages';
import SalHandoff from './components/SalHandoff';

export default function SalesOperationsPage() {
  return <ServicePageTemplate data={salesOperations} system={<SalHandoff />} />;
}